module.exports = __webpack_public_path__ + "img/portugal-external-causes-female.7fd81d2d.png";